var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93164 5.85938C4.31032 5.85938 3.80664 6.36305 3.80664 6.98438V18.2344C3.80664 18.8557 4.31032 19.3594 4.93164 19.3594H20.6816C21.303 19.3594 21.8066 18.8557 21.8066 18.2344V6.98438C21.8066 6.36305 21.303 5.85938 20.6816 5.85938H4.93164ZM2.30664 6.98438C2.30664 5.53463 3.48189 4.35938 4.93164 4.35938H20.6816C22.1314 4.35938 23.3066 5.53463 23.3066 6.98438V18.2344C23.3066 19.6841 22.1314 20.8594 20.6816 20.8594H4.93164C3.48189 20.8594 2.30664 19.6841 2.30664 18.2344V6.98438Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46466 7.64895C5.71896 7.32199 6.19017 7.26309 6.51713 7.5174L12.8067 12.4093L19.0962 7.5174C19.4232 7.26309 19.8944 7.32199 20.1487 7.64895C20.403 7.97591 20.3441 8.44712 20.0171 8.70142L13.2671 13.9514C12.9963 14.1621 12.6171 14.1621 12.3462 13.9514L5.59622 8.70142C5.26926 8.44712 5.21036 7.97591 5.46466 7.64895Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.16a50e98417da6d1c5fe914717f7bed4.svg";
export { ForwardRef as ReactComponent };